import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import SpacReadOnly from '../components/SpacReadOnly';

const SpacPage = () => {
  return (
    <>
      <h2 className="TitleGrid">
        <Trans>Capacitaciones pendientes por spac</Trans>{' '}
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <SpacReadOnly />
    </>
  );
};

export default SpacPage;
